export const projects = [
  {
    title: "NetFlix Clone App",
    subDescription: "(under developement)",
    description:
      "A Blog website and app, coming up with beautiful animations and exciting UI design.",
    image: "/assests/netflix.png",
    tags: ["React", "CSS"],
    source: "https://github.com/Dipeshpatil-doof/netflix-clone",
    visit: "https://dprivys-netflix-clone.netlify.app/",
    id: 0,
  },
  {
    title: "Dkrypt",
    subDescription: "(coming soon)",
    description:
      "A Modern Web3.0 app based on blockchain lifeCycle with exciting UI/UX. Building smart contracts on etherium",
    image: "/assests/dkrypt.png",
    tags: ["React", "Etherium", "tailwindCss"],
    source: "",
    visit: "",
    id: 1,
  },
  {
    title: "News Reader AI App",
    description:
      "This is Real time news reader AI application build with Alan AI. It has real time voice assistance for news fetching",
    image: "/assests/alanai.png",
    tags: ["React", "Alan AI", "tailwindcss"],
    source: "https://github.com/Dipesh107/news-reader-alanai",
    visit: "https://dprivys-news-reader.netlify.app/",
    id: 2,
  },
  {
    title: "Chat-Kar",
    description:
      "This is Real time chat application created using chat-engine and firebase. It provides Google Authentication.",
    image: "/assests/chatkar.png",
    tags: ["React", "ChatEngine", "Firebase", "tailwindcss"],
    source: "https://github.com/Dipesh107/chat-app",
    visit: "https://chat-kar.netlify.app/",
    id: 3,
  },
  {
    title: "MS Teams Clone",
    description:
      "This is Real time chat application created using chat-engine and firebase. It includes email signin authentication.",
    image: "/assests/msTeams.png",
    tags: ["React", "ChatEngine", "Firebase"],
    source: "https://github.com/Dipesh107/chat-engine-ms-teams-",
    visit: "https://dprivys-chatengine.netlify.app/",
    id: 4,
  },
  {
    title: "Quiziey",
    description:
      "A Simple Quiz app consisting of 10 questions which can calculate your score on your preformance.",
    image: "/assests/quiziey.png",
    tags: ["React", "Material UI"],
    source: "https://github.com/Dipesh107/quiziey",
    visit: "https://quiziey.herokuapp.com/",
    id: 5,
  },
  {
    title: "PyMonk Travels",
    description:
      " Online Ticket Booking website developed for customers for booking flights, trains, buses and hotels online fot their trips.",
    image: "/assests/pymonkproject.png",
    tags: ["Pyhton", "Django", "Postgress SQL"],
    source: "https://github.com/Dipesh107/pymonk-travels",
    visit: "",
    id: 6,
  },
  {
    title: "The Borrow Trend",
    description:
      "An online e-commerce rental website for buying and renting all fashion related things like Jewellery, Shoes, Clothes and other material related to fashion.",
    image: "/assests/borrowtrendproject.png",
    tags: ["Mongo", "Express", "Node"],
    source: "https://github.com/Dipesh107/BorrowTrend",
    visit: "",
    id: 7,
  },
  {
    title: "Greendoors",
    subDescription: "(unavailable)",
    description:
      "Business website for home painting and exterior painting with all services options from booking home visits to choosing colors for homes.",
    image: "/assests/borrowtrendproject.png",
    tags: ["React", "JavaScript"],
    source: "https://github.com/whodissaket/greendoors",
    visit: "",
    id: 8,
  },
  {
    title: "Dope Web",
    subDescription: "(under developement)",
    description:
      "A Blog website and app, coming up with beautiful animations and exciting UI design.",
    image: "/assests/devblog.png",
    tags: ["React", "Material UI", "firebase", "framer motion"],
    source: "https://github.com/Dipesh107/DopeWeb",
    visit: "",
    id: 9,
  },
];
